import * as React from "react";
import { SVGProps, memo } from "react";

const SvgRadioError = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#RadioError_svg__a)">
      <circle cx={10} cy={10} r={9.5} fill="#FFEDEB" stroke="#E2341D" />
    </g>

    <defs>
      <clipPath id="RadioError_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgRadioError);

export default Memo;
